export default __webpack_public_path__ + "static/media/brainHealthStudio2.7f3c5a62.png";